<template>
  <div v-if="start">
    <div class="w-full">
      <div class="my-6" v-can="'company.manage'">
        <vs-button :to="{name: 'scenarios_add'}">Добавить бота</vs-button>
      </div>
      <div class="scenarios-list" v-if="scenarios.length > 0">
        <div class="scenarios-list__item" v-for="(scenario, index) in scenarios" :key="index">
          <ScenarioCard
            :slug="scenario.slug"
            :name="scenario.name"
            :description="scenario.description"
            @delete="handleDelete"
          />
        </div>
      </div>
      <div v-else>
        <p>У вас нет ни одного чат-бота. Создайте нового чат-бота, чтобы получить доступ к функционалу сервиса.</p>
      </div>
    </div>
  </div>
</template>

<script>
import Scenarios from '../../api/http/models/Scenarios'
import ScenarioCard from './components/ScenarioCard'

import {mapGetters} from 'vuex'

export default {
  data () {
    return {
      start: false,
      deletingScenario: {},
      scenarios: []
    }
  },
  computed: mapGetters(['authUserCompany']),
  components: {
    ScenarioCard
  },
  async created () {
    const response = await Scenarios.getAll(this.authUserCompany.slug)
    if (response.data) {
      this.scenarios = response.data.reverse()
    }

    this.start = true
  },
  methods: {
    handleDelete (scenarioSlug) {
      const deleteScenario = async () => {
        const response = await Scenarios.deleteOne(this.authUserCompany.slug, this.deletingScenario.slug)

        if (response.status === 'success') {
          const index = this.scenarios.findIndex(scenario => this.deletingScenario.slug === scenario.slug)
          this.scenarios.splice(index, 1)
          this.$vs.notify({
            color: 'success',
            title: 'Удаление прошло успешно',
            text: `Чат-бот «‎‎${this.deletingScenario.name}» был удален из системы`,
            icon: 'check_box'
          })
        } else if (response.status === 'no_changes') {
          this.$vs.notify({
            color: 'warning',
            title: 'Невозможно удалить',
            text: `К чат-боту «‎‎${this.deletingScenario.name}» подключены каналы. Отсоедините их и попробуйте еще раз`,
            icon: 'error'
          })
        } else {
          this.$vs.notify({
            color: 'danger',
            title: 'Произошла ошибка',
            text: ''
          })
        }
      }

      this.deletingScenario = this.scenarios.find(scenario => scenario.slug === scenarioSlug)
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Вы действительно хотите удалить чат-бота «${this.deletingScenario.name}» из Yolker?`,
        text: `Чат-бот «${this.deletingScenario.name}» будет удалена из системы`,
        accept: deleteScenario,
        acceptText: 'Удалить',
        cancelText: 'Отменить'
      })
    }
  }
}
</script>

<style lang="scss">
  .scenarios-list {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -1rem;

    &__item {
      padding: 0 1rem;
      margin-bottom: 2rem;
      width: 100%;
      @media (min-width: 680px) {
        width: 50%;
      }
      @media (min-width: 960px) {
        width: 33.333%;
      }
      @media (min-width: 1400px) {
        width: 25%;
      }
    }
  }
</style>
